var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9719 8.27202L21.8542 2.04628C21.1979 1.37844 20.3083 1 19.3823 1H4.5C2.56771 1.00742 1 2.60281 1 4.56922V35.4382C1 37.4046 2.56771 39 4.5 39H25.5C27.4323 39 29 37.4046 29 35.4382V10.795C29 9.85257 28.6281 8.93986 27.9719 8.27202ZM26.324 9.95645C26.4771 10.1123 26.5792 10.2978 26.6302 10.5056H19.6667V3.41906C19.8708 3.471 20.0531 3.57489 20.2062 3.73072L26.324 9.95645ZM25.5 36.6255H4.5C3.85833 36.6255 3.33333 36.0912 3.33333 35.4382V4.56922C3.33333 3.91623 3.85833 3.38196 4.5 3.38196H17.3333V11.0992C17.3333 12.0861 18.1135 12.8801 19.0833 12.8801H26.6667V35.4382C26.6667 36.0912 26.1417 36.6255 25.5 36.6255ZM22 19.5196V20.1133C22 20.603 21.6063 21.0037 21.125 21.0037H8.875C8.39375 21.0037 8 20.603 8 20.1133V19.5196C8 19.0299 8.39375 18.6292 8.875 18.6292H21.125C21.6063 18.6292 22 19.0299 22 19.5196ZM22 27.0178V27.6114C22 28.1012 21.6063 28.5019 21.125 28.5019H8.875C8.39375 28.5019 8 28.1012 8 27.6114V27.0178C8 26.528 8.39375 26.1273 8.875 26.1273H21.125C21.6063 26.1273 22 26.528 22 27.0178Z",
    fill: "#335C75",
    stroke: "#335C75",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/InvoiceIcon.f993ace7170f84a62ec44c435b64bb0e.svg";
export { ForwardRef as ReactComponent };